export default [
  {
    id: 1,
    value: '情感',
    children: [
      {
        id: 29,
        value: '情感生活'
      },
      {
        id: 30,
        value: '感情文化'
      },
      {
        id: 31,
        value: '年代秀'
      },
      {
        id: 32,
        value: '美色'
      },
      {
        id: 33,
        value: '恋爱'
      },
      {
        id: 34,
        value: '其他情感话题'
      },
      {
        id: 35,
        value: '男性话题'
      },
      {
        id: 36,
        value: '婚姻家庭'
      },
      {
        id: 37,
        value: '女性话题'
      }
    ]
  },
  {
    id: 2,
    value: '地区',
    children: [
      {
        id: 38,
        value: '北京'
      },
      {
        id: 39,
        value: '重庆'
      },
      {
        id: 40,
        value: '新疆'
      },
      {
        id: 41,
        value: '广东'
      },
      {
        id: 42,
        value: '浙江'
      },
      {
        id: 43,
        value: '天津'
      },
      {
        id: 44,
        value: '广西'
      },
      {
        id: 45,
        value: '内蒙古'
      },
      {
        id: 46,
        value: '宁夏'
      },
      {
        id: 47,
        value: '江西'
      },
      {
        id: 48,
        value: '贵州'
      },
      {
        id: 49,
        value: '安徽'
      },
      {
        id: 50,
        value: '陕西'
      },
      {
        id: 51,
        value: '辽宁'
      },
      {
        id: 52,
        value: '山西'
      },
      {
        id: 53,
        value: '港澳台'
      },
      {
        id: 54,
        value: '青海'
      },
      {
        id: 55,
        value: '四川'
      },
      {
        id: 56,
        value: '江苏'
      },
      {
        id: 57,
        value: '其他地区及话题'
      },
      {
        id: 58,
        value: '河北'
      },
      {
        id: 59,
        value: '西藏'
      },
      {
        id: 60,
        value: '福建'
      },
      {
        id: 61,
        value: '吉林'
      },
      {
        id: 62,
        value: '湖北'
      },
      {
        id: 63,
        value: '海南'
      },
      {
        id: 64,
        value: '云南'
      },
      {
        id: 65,
        value: '上海'
      },
      {
        id: 66,
        value: '甘肃'
      },
      {
        id: 67,
        value: '湖南'
      },
      {
        id: 68,
        value: '河南'
      },
      {
        id: 69,
        value: '山东'
      },
      {
        id: 70,
        value: '海外'
      },
      {
        id: 71,
        value: '黑龙江'
      }
    ]
  },
  {
    id: 3,
    value: '金融',
    children: [
      {
        id: 72,
        value: '沪市A股'
      },
      {
        id: 73,
        value: '期货/权证'
      },
      {
        id: 74,
        value: '债券'
      },
      {
        id: 75,
        value: '其他金融服务及产品'
      },
      {
        id: 76,
        value: '金融组织机构'
      },
      {
        id: 77,
        value: '深市A股'
      },
      {
        id: 78,
        value: '基金'
      }
    ]
  },
  {
    id: 4,
    value: '网友俱乐部',
    children: [
      {
        id: 79,
        value: '网友俱乐部'
      },
      {
        id: 80,
        value: '个人贴吧'
      },
      {
        id: 81,
        value: '其他'
      },
      {
        id: 82,
        value: '百度知道用户团队'
      },
      {
        id: 83,
        value: '虚拟角色扮演'
      }
    ]
  },
  {
    id: 5,
    value: '生活',
    children: [
      {
        id: 84,
        value: '旅游'
      },
      {
        id: 85,
        value: '时尚美容'
      },
      {
        id: 86,
        value: '宠物'
      },
      {
        id: 87,
        value: '休闲活动'
      },
      {
        id: 88,
        value: '原创音视频话题'
      },
      {
        id: 89,
        value: '母婴'
      },
      {
        id: 90,
        value: '贴图'
      },
      {
        id: 91,
        value: '杂志期刊'
      },
      {
        id: 92,
        value: '兴趣收藏'
      },
      {
        id: 93,
        value: '节日'
      },
      {
        id: 94,
        value: '娱乐八卦'
      },
      {
        id: 95,
        value: '饮食'
      },
      {
        id: 96,
        value: '其他生活话题'
      },
      {
        id: 97,
        value: '星座运势'
      },
      {
        id: 98,
        value: '健康保健'
      }
    ]
  },
  {
    id: 6,
    value: '电脑数码',
    children: [
      {
        id: 99,
        value: '电脑数码话题'
      },
      {
        id: 100,
        value: '数码家电'
      },
      {
        id: 101,
        value: '手机'
      },
      {
        id: 102,
        value: '电脑及硬件'
      }
    ]
  },
  {
    id: 7,
    value: '动漫',
    children: [
      {
        id: 103,
        value: '动漫相关'
      },
      {
        id: 104,
        value: '动漫角色'
      },
      {
        id: 105,
        value: '动漫作者'
      },
      {
        id: 106,
        value: '动漫·轻小说作品'
      },
      {
        id: 107,
        value: '动漫声优'
      },
      {
        id: 108,
        value: '动漫同人'
      }
    ]
  },
  {
    id: 8,
    value: '百度服务中心',
    children: [
      {
        id: 109,
        value: '百度其他产品服务'
      },
      {
        id: 110,
        value: '贴吧管理中心'
      },
      {
        id: 111,
        value: '贴吧活动与交流'
      }
    ]
  },
  {
    id: 9,
    value: '电影',
    children: [
      {
        id: 112,
        value: '其他地区电影'
      },
      {
        id: 113,
        value: '香港电影'
      },
      {
        id: 114,
        value: '东南亚电影'
      },
      {
        id: 115,
        value: '电影话题'
      },
      {
        id: 116,
        value: '韩国电影'
      },
      {
        id: 117,
        value: '欧美电影'
      },
      {
        id: 118,
        value: '内地电影'
      },
      {
        id: 119,
        value: '日本电影'
      },
      {
        id: 120,
        value: '台湾电影'
      }
    ]
  },
  {
    id: 10,
    value: '游戏',
    children: [
      {
        id: 121,
        value: '掌机游戏'
      },
      {
        id: 122,
        value: '游戏角色'
      },
      {
        id: 123,
        value: '小游戏'
      },
      {
        id: 124,
        value: '其他游戏及话题'
      },
      {
        id: 125,
        value: '单机游戏'
      },
      {
        id: 126,
        value: '桌游'
      },
      {
        id: 127,
        value: '手机游戏'
      },
      {
        id: 128,
        value: '客户端网游'
      },
      {
        id: 129,
        value: '电视游戏'
      },
      {
        id: 130,
        value: '网页版网游'
      }
    ]
  },
  {
    id: 11,
    value: '体育',
    children: [
      {
        id: 131,
        value: '体操明星'
      },
      {
        id: 132,
        value: '西班牙足球俱乐部及赛事'
      },
      {
        id: 133,
        value: '乒羽明星'
      },
      {
        id: 134,
        value: '其他体育项目及赛事'
      },
      {
        id: 135,
        value: 'nba球队及赛事'
      },
      {
        id: 136,
        value: '篮球明星'
      },
      {
        id: 137,
        value: '水上运动'
      },
      {
        id: 138,
        value: '其他足球俱乐部及赛事'
      },
      {
        id: 139,
        value: '电子竞技及选手'
      },
      {
        id: 140,
        value: '冬季项目明星'
      },
      {
        id: 141,
        value: '棋牌类'
      },
      {
        id: 142,
        value: '田径明星'
      },
      {
        id: 143,
        value: '休闲体育'
      },
      {
        id: 144,
        value: '台球明星'
      },
      {
        id: 145,
        value: '其他体育明星'
      },
      {
        id: 146,
        value: '法国足球俱乐部及赛事'
      },
      {
        id: 147,
        value: '田径'
      },
      {
        id: 148,
        value: '足球明星'
      },
      {
        id: 149,
        value: '网球明星'
      },
      {
        id: 150,
        value: '英国足球俱乐部及赛事'
      },
      {
        id: 151,
        value: '排球'
      },
      {
        id: 152,
        value: '舞蹈'
      },
      {
        id: 153,
        value: '水上运动明星'
      },
      {
        id: 154,
        value: '德国足球俱乐部及赛事'
      },
      {
        id: 155,
        value: '冰上运动'
      },
      {
        id: 156,
        value: '武术搏击'
      },
      {
        id: 157,
        value: '中国足球俱乐部及赛事'
      },
      {
        id: 158,
        value: '体育相关话题'
      },
      {
        id: 159,
        value: '乒羽·网球'
      },
      {
        id: 160,
        value: '台球'
      },
      {
        id: 161,
        value: '赛车'
      },
      {
        id: 162,
        value: '体育记者及媒体'
      },
      {
        id: 163,
        value: 'cba球队及赛事'
      },
      {
        id: 164,
        value: '排球明星'
      },
      {
        id: 165,
        value: '足球国家队及协会'
      },
      {
        id: 166,
        value: '篮球国家队、协会及赛事'
      },
      {
        id: 167,
        value: '意大利足球俱乐部及赛事'
      },
      {
        id: 168,
        value: '赛车明星'
      }
    ]
  },
  {
    id: 12,
    value: '电视剧',
    children: [
      {
        id: 169,
        value: '电视剧话题'
      },
      {
        id: 170,
        value: '电视剧角色'
      },
      {
        id: 171,
        value: '韩国电视剧'
      },
      {
        id: 172,
        value: '其他地区电视剧'
      },
      {
        id: 173,
        value: '日本电视剧'
      },
      {
        id: 174,
        value: '东南亚电视剧'
      },
      {
        id: 175,
        value: '美剧'
      },
      {
        id: 176,
        value: '台湾电视剧'
      },
      {
        id: 177,
        value: '香港电视剧'
      },
      {
        id: 178,
        value: '内地电视剧'
      },
      {
        id: 179,
        value: '音乐制作人'
      }
    ]
  },
  {
    id: 13,
    value: '娱乐明星',
    children: [
      {
        id: 180,
        value: '2012中国好声音'
      },
      {
        id: 181,
        value: '韩国明星'
      },
      {
        id: 182,
        value: '导演'
      },
      {
        id: 183,
        value: '内地明星'
      },
      {
        id: 184,
        value: '港台东南亚明星'
      },
      {
        id: 185,
        value: '其他娱乐明星'
      },
      {
        id: 186,
        value: '明星官方吧'
      },
      {
        id: 187,
        value: '娱乐明星话题'
      },
      {
        id: 188,
        value: '主持人'
      },
      {
        id: 189,
        value: '其他粉丝组织'
      },
      {
        id: 190,
        value: '日本明星'
      },
      {
        id: 191,
        value: '时尚人物'
      },
      {
        id: 192,
        value: '戏曲曲艺明星'
      },
      {
        id: 193,
        value: '欧美明星'
      }
    ]
  },
  {
    id: 14,
    value: '中小学',
    children: [
      {
        id: 194,
        value: '海南中小学'
      },
      {
        id: 195,
        value: '北京中小学'
      },
      {
        id: 196,
        value: '广西中小学'
      },
      {
        id: 197,
        value: '重庆中小学'
      },
      {
        id: 198,
        value: '云南中小学'
      },
      {
        id: 199,
        value: '宁夏中小学'
      },
      {
        id: 200,
        value: '上海中小学'
      },
      {
        id: 201,
        value: '山东中小学'
      },
      {
        id: 202,
        value: '河北中小学'
      },
      {
        id: 203,
        value: '青海中小学'
      },
      {
        id: 204,
        value: '湖北中小学'
      },
      {
        id: 205,
        value: '浙江中小学'
      },
      {
        id: 206,
        value: '辽宁中小学'
      },
      {
        id: 207,
        value: '其他地区中小学及话题'
      },
      {
        id: 208,
        value: '甘肃中小学'
      },
      {
        id: 209,
        value: '新疆中小学'
      },
      {
        id: 210,
        value: '天津中小学'
      },
      {
        id: 211,
        value: '福建中小学'
      },
      {
        id: 212,
        value: '山西中小学'
      },
      {
        id: 213,
        value: '江西中小学'
      },
      {
        id: 214,
        value: '内蒙古中小学'
      },
      {
        id: 215,
        value: '吉林中小学'
      },
      {
        id: 216,
        value: '江苏中小学'
      },
      {
        id: 217,
        value: '贵州中小学'
      },
      {
        id: 218,
        value: '湖南中小学'
      },
      {
        id: 219,
        value: '河南中小学'
      },
      {
        id: 220,
        value: '安徽中小学'
      },
      {
        id: 221,
        value: '西藏中小学'
      },
      {
        id: 222,
        value: '陕西中小学'
      },
      {
        id: 223,
        value: '黑龙江中小学'
      },
      {
        id: 224,
        value: '四川中小学'
      },
      {
        id: 225,
        value: '广东中小学'
      }
    ]
  },
  {
    id: 15,
    value: '文学',
    children: [
      {
        id: 226,
        value: '严肃小说'
      },
      {
        id: 227,
        value: '其他小说作品'
      },
      {
        id: 228,
        value: '都市·言情小说'
      },
      {
        id: 229,
        value: '儿童文学'
      },
      {
        id: 230,
        value: '文学话题'
      },
      {
        id: 231,
        value: '科幻小说'
      },
      {
        id: 232,
        value: '中国近现代作家'
      },
      {
        id: 233,
        value: '外国作家'
      },
      {
        id: 234,
        value: '中国当代作家'
      },
      {
        id: 235,
        value: '当代其他文学作品'
      },
      {
        id: 236,
        value: '奇幻·玄幻小说'
      },
      {
        id: 237,
        value: '近现代文学作品'
      },
      {
        id: 238,
        value: '古典文学'
      },
      {
        id: 239,
        value: '灵异·超能力小说'
      },
      {
        id: 240,
        value: '文学期刊'
      },
      {
        id: 241,
        value: '文学人物'
      },
      {
        id: 242,
        value: '古言小说'
      },
      {
        id: 243,
        value: '悬疑·推理小说'
      },
      {
        id: 244,
        value: '外国文学'
      },
      {
        id: 245,
        value: '军事·历史小说'
      },
      {
        id: 246,
        value: '中国古代作家'
      },
      {
        id: 247,
        value: '传统武侠小说'
      },
      {
        id: 248,
        value: '游戏小说'
      }
    ]
  },
  {
    id: 16,
    value: '社会',
    children: [
      {
        id: 249,
        value: '职业话题'
      },
      {
        id: 250,
        value: '社会机构'
      },
      {
        id: 251,
        value: '医疗机构'
      },
      {
        id: 252,
        value: '公益慈善'
      },
      {
        id: 253,
        value: '社会事件及话题'
      }
    ]
  },
  {
    id: 17,
    value: '人文自然',
    children: [
      {
        id: 254,
        value: '鉴赏收藏'
      },
      {
        id: 255,
        value: '姓氏文化'
      },
      {
        id: 256,
        value: '宗教'
      },
      {
        id: 257,
        value: '自然'
      },
      {
        id: 258,
        value: '动植物'
      },
      {
        id: 259,
        value: '历史'
      },
      {
        id: 260,
        value: '语言文化'
      },
      {
        id: 261,
        value: '其他自然话题'
      },
      {
        id: 262,
        value: '其他人文话题'
      },
      {
        id: 263,
        value: '社会科学话题'
      },
      {
        id: 264,
        value: '民族文化'
      },
      {
        id: 265,
        value: '艺术'
      },
      {
        id: 266,
        value: '军事'
      }
    ]
  },
  {
    id: 18,
    value: '企业',
    children: [
      {
        id: 267,
        value: '餐饮美食'
      },
      {
        id: 268,
        value: '食品饮料企业'
      },
      {
        id: 269,
        value: '建筑业'
      },
      {
        id: 270,
        value: '机械设备'
      },
      {
        id: 271,
        value: '企业话题'
      },
      {
        id: 272,
        value: '生活服务业'
      },
      {
        id: 273,
        value: '服装服饰企业'
      },
      {
        id: 274,
        value: '商务服务业'
      },
      {
        id: 275,
        value: '家居用品'
      },
      {
        id: 276,
        value: '包装/印刷/纸业'
      },
      {
        id: 277,
        value: 'IT行业'
      },
      {
        id: 278,
        value: '数码家电'
      },
      {
        id: 279,
        value: '商场购物'
      },
      {
        id: 280,
        value: '汽车制造业'
      },
      {
        id: 281,
        value: '能源/冶金/建材'
      },
      {
        id: 282,
        value: '批发零售业'
      },
      {
        id: 283,
        value: '房地产'
      },
      {
        id: 284,
        value: '纺织/化工/化学品'
      },
      {
        id: 285,
        value: '医药保健企业'
      },
      {
        id: 286,
        value: '互联网企业'
      },
      {
        id: 287,
        value: '美容保健'
      },
      {
        id: 288,
        value: '农林牧渔'
      },
      {
        id: 289,
        value: '娱乐休闲'
      },
      {
        id: 290,
        value: '其他类型企业'
      },
      {
        id: 291,
        value: '交通运输、仓储和邮政业'
      }
    ]
  },
  {
    id: 19,
    value: '高等院校',
    children: [
      {
        id: 292,
        value: '云南院校'
      },
      {
        id: 293,
        value: '河南院校'
      },
      {
        id: 294,
        value: '贵州院校'
      },
      {
        id: 295,
        value: '山东院校'
      },
      {
        id: 296,
        value: '江西院校'
      },
      {
        id: 297,
        value: '湖北院校'
      },
      {
        id: 298,
        value: '山西院校'
      },
      {
        id: 299,
        value: '上海院校'
      },
      {
        id: 300,
        value: '海南院校'
      },
      {
        id: 301,
        value: '新疆院校'
      },
      {
        id: 302,
        value: '校园青春'
      },
      {
        id: 303,
        value: '港澳台院校'
      },
      {
        id: 304,
        value: '内蒙古院校'
      },
      {
        id: 305,
        value: '重庆院校'
      },
      {
        id: 306,
        value: '安徽院校'
      },
      {
        id: 307,
        value: '天津院校'
      },
      {
        id: 308,
        value: '海外院校'
      },
      {
        id: 309,
        value: '吉林院校'
      },
      {
        id: 310,
        value: '陕西院校'
      },
      {
        id: 311,
        value: '河北院校'
      },
      {
        id: 312,
        value: '宁夏院校'
      },
      {
        id: 313,
        value: '学校话题'
      },
      {
        id: 314,
        value: '黑龙江院校'
      },
      {
        id: 315,
        value: '湖南院校'
      },
      {
        id: 316,
        value: '浙江院校'
      },
      {
        id: 317,
        value: '江苏院校'
      },
      {
        id: 318,
        value: '福建院校'
      },
      {
        id: 319,
        value: '四川院校'
      },
      {
        id: 320,
        value: '甘肃院校'
      },
      {
        id: 321,
        value: '广西院校'
      },
      {
        id: 322,
        value: '青海院校'
      },
      {
        id: 323,
        value: '辽宁院校'
      },
      {
        id: 324,
        value: '西藏院校'
      },
      {
        id: 325,
        value: '广东院校'
      },
      {
        id: 326,
        value: '北京院校'
      }
    ]
  },
  {
    id: 20,
    value: '当代人物',
    children: [
      {
        id: 327,
        value: '当代社会科学人物'
      },
      {
        id: 328,
        value: '热点新闻人物'
      },
      {
        id: 329,
        value: '当代军事政治人物'
      },
      {
        id: 330,
        value: '商业人物'
      },
      {
        id: 331,
        value: '当代艺术人物'
      },
      {
        id: 332,
        value: '当代自然科学人物'
      },
      {
        id: 333,
        value: '其他当代人物'
      }
    ]
  },
  {
    id: 21,
    value: '音乐',
    children: [
      {
        id: 334,
        value: '欧美流行音乐'
      },
      {
        id: 335,
        value: '港台流行音乐'
      },
      {
        id: 336,
        value: '摇滚音乐'
      },
      {
        id: 337,
        value: '古典音乐&轻音乐'
      },
      {
        id: 338,
        value: '民歌'
      },
      {
        id: 339,
        value: '乐器'
      },
      {
        id: 340,
        value: '日本流行音乐'
      },
      {
        id: 341,
        value: '少儿歌曲'
      },
      {
        id: 342,
        value: '内地流行音乐'
      },
      {
        id: 343,
        value: '韩国流行音乐'
      },
      {
        id: 344,
        value: '其他地区流行音乐'
      },
      {
        id: 345,
        value: '音乐话题'
      }
    ]
  },
  {
    id: 22,
    value: '科学技术',
    children: [
      {
        id: 346,
        value: '其他计算机相关'
      },
      {
        id: 347,
        value: '计算机软件'
      },
      {
        id: 348,
        value: '互联网产品及话题'
      },
      {
        id: 349,
        value: '其他科技话题'
      },
      {
        id: 350,
        value: '自然科学话题'
      },
      {
        id: 351,
        value: '程序设计'
      }
    ]
  },
  {
    id: 23,
    value: '商业服务',
    children: [
      {
        id: 352,
        value: '生活服务'
      },
      {
        id: 353,
        value: '交通运输'
      },
      {
        id: 354,
        value: '网络通信服务'
      },
      {
        id: 355,
        value: '其他类型服务'
      },
      {
        id: 356,
        value: '商务服务'
      },
      {
        id: 357,
        value: '开采·加工'
      }
    ]
  },
  {
    id: 24,
    value: '生活用品',
    children: [
      {
        id: 358,
        value: '家居用品'
      },
      {
        id: 359,
        value: '服装服饰'
      },
      {
        id: 360,
        value: '交通工具、配件及设施'
      },
      {
        id: 361,
        value: '食品饮料'
      },
      {
        id: 362,
        value: '箱包配饰'
      },
      {
        id: 363,
        value: '其他生活用品及话题'
      },
      {
        id: 364,
        value: '个护化妆'
      },
      {
        id: 365,
        value: '文教·体育·娱乐和工美用品'
      },
      {
        id: 366,
        value: '汽车及配件'
      },
      {
        id: 367,
        value: '医药保健'
      }
    ]
  },
  {
    id: 25,
    value: '历史人物',
    children: [
      {
        id: 368,
        value: '中国近现代历史人物'
      },
      {
        id: 369,
        value: '历史人物话题'
      },
      {
        id: 370,
        value: '中国古代历史人物'
      },
      {
        id: 371,
        value: '外国历史人物'
      }
    ]
  },
  {
    id: 26,
    value: '教育培训',
    children: [
      {
        id: 372,
        value: '培训机构'
      },
      {
        id: 373,
        value: '外语学习'
      },
      {
        id: 374,
        value: '基础教育'
      },
      {
        id: 375,
        value: '高等教育'
      },
      {
        id: 376,
        value: '留学'
      },
      {
        id: 377,
        value: '教育话题'
      },
      {
        id: 378,
        value: '职业技能考试与培训'
      }
    ]
  },
  {
    id: 27,
    value: '电视节目',
    children: [
      {
        id: 379,
        value: '音乐·文艺'
      },
      {
        id: 380,
        value: '其他节目及话题'
      },
      {
        id: 381,
        value: '广播电台'
      },
      {
        id: 382,
        value: '电视台及频道'
      },
      {
        id: 383,
        value: '财经·职场'
      },
      {
        id: 384,
        value: '少儿·教育'
      },
      {
        id: 385,
        value: '内地综艺'
      },
      {
        id: 386,
        value: '韩国综艺'
      },
      {
        id: 387,
        value: '时尚·生活服务'
      },
      {
        id: 388,
        value: '台湾综艺'
      },
      {
        id: 389,
        value: '科教记录·社会与法'
      },
      {
        id: 390,
        value: '体育运动·健身'
      },
      {
        id: 391,
        value: '新闻资讯'
      }
    ]
  },
  {
    id: 28,
    value: '工农业产品',
    children: [
      {
        id: 392,
        value: '农林牧渔'
      },
      {
        id: 393,
        value: '电子电工'
      },
      {
        id: 394,
        value: '包装/印刷/纸业'
      },
      {
        id: 395,
        value: '能源/冶金/建材'
      },
      {
        id: 396,
        value: '纺织/化工/化学品'
      },
      {
        id: 397,
        value: '其他工农业产品及话题'
      },
      {
        id: 398,
        value: '机械设备'
      },
      {
        id: 399,
        value: '安全防护'
      },
      {
        id: 400,
        value: '医疗器械'
      }
    ]
  },
  {
    id: 401,
    value: '其他'
  },
  {
    id: 402,
    value: '其他二'
  }
]
